<template>
  <v-card elevation="2">
    <v-toolbar color="indigo" dark flat>
      <v-icon left>mdi-file-document-multiple</v-icon>
      <v-toolbar-title>Client Files</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('add-file')" v-if="canEdit">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card-text v-if="files.length === 0" class="text-center py-8">
      <v-icon size="64" color="grey lighten-1">mdi-folder-open</v-icon>
      <p class="text-h6 grey--text mt-4">No files yet</p>
      <v-btn color="indigo" dark @click="$emit('add-file')" v-if="canEdit">
        <v-icon left>mdi-plus</v-icon>
        Add First File
      </v-btn>
    </v-card-text>

    <v-list v-else two-line>
      <template v-for="(file, index) in files">
        <v-list-item :key="file.id" @click="$emit('view-file', file)">
          <v-list-item-avatar>
            <v-icon :color="getFileColor(file.type)">
              {{ getFileIcon(file.type) }}
            </v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ file.title }}</v-list-item-title>
            <v-list-item-subtitle>
              {{ file.description }}
            </v-list-item-subtitle>
            <v-list-item-subtitle class="text-caption">
              {{ formatDate(file.date) }}
            </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action v-if="canEdit">
            <v-menu bottom left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="$emit('edit-file', file)">
                  <v-list-item-icon>
                    <v-icon>mdi-pencil</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Edit</v-list-item-title>
                </v-list-item>
                <v-list-item @click="$emit('download-file', file)">
                  <v-list-item-icon>
                    <v-icon>mdi-download</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Download</v-list-item-title>
                </v-list-item>
                <v-list-item @click="$emit('delete-file', file.id)">
                  <v-list-item-icon>
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Delete</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-list-item-action>
        </v-list-item>
        <v-divider
          :key="'div-' + index"
          v-if="index < files.length - 1"
        ></v-divider>
      </template>
    </v-list>
  </v-card>
</template>

<script>
export default {
  name: "GeneralFiles",

  props: {
    files: {
      type: Array,
      default: () => [],
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    getFileIcon(type) {
      const icons = {
        document: "mdi-file-document",
        contract: "mdi-file-sign",
        invoice: "mdi-receipt",
        quote: "mdi-file-document-outline",
        agreement: "mdi-handshake",
        report: "mdi-chart-box",
      };

      return icons[type] || "mdi-file";
    },

    getFileColor(type) {
      const colors = {
        document: "blue",
        contract: "green",
        invoice: "orange",
        quote: "purple",
        agreement: "teal",
        report: "indigo",
      };

      return colors[type] || "grey";
    },

    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleDateString();
    },
  },
};
</script>
